import React, { useCallback, useEffect } from "react";
import { Modal } from "../../common/Modal/Modal";
import { PrimaryButton, TitleStyle } from "../../common/common.style";
import { CardSelected } from "../../../type";
import { Box, FlexBox } from "../../primitives";
import localforage from "localforage";

interface ModalDeleteAllProps {
  setIsDeleteAll: (arg1: boolean) => void;
  setCardsBoard: (arg1: CardSelected[]) => void;
}

export const ModalDeleteAll = ({
  setIsDeleteAll,
  setCardsBoard,
}: ModalDeleteAllProps) => {
  const commonOnConfirm = useCallback(async () => {
    await localforage.removeItem("cardsBoard");
    setIsDeleteAll(false);
    setCardsBoard([]);
  }, [setIsDeleteAll, setCardsBoard]);

  const commonOnExit = useCallback(() => {
    setIsDeleteAll(false);
  }, [setIsDeleteAll]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Enter") {
        commonOnConfirm();
      } else if (e.key === "Escape") {
        commonOnExit();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [commonOnConfirm, commonOnExit, setCardsBoard, setIsDeleteAll]);

  return (
    <Modal onClose={() => commonOnExit()} modalStyle={{ width: 400 }}>
      <TitleStyle>Are you sure to delete all ?</TitleStyle>
      <FlexBox
        style={{
          marginTop: 20,
          justifyContent: "center",
          alignItems: "center",
          gap: 20,
        }}
      >
        <PrimaryButton
          onClick={() => {
            commonOnConfirm();
          }}
        >
          <Box>CONFIRM</Box>
          <Box>( ENTER )</Box>
        </PrimaryButton>
        <PrimaryButton
          onClick={() => {
            commonOnExit();
          }}
        >
          <Box>CLOSE</Box>
          <Box>( ESC )</Box>
        </PrimaryButton>
      </FlexBox>
    </Modal>
  );
};
